/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Vakanties_VerwijderenInputs */

const nl_planning_vakanties_verwijderen = /** @type {(inputs: Planning_Vakanties_VerwijderenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.naam} verwijderen`)
};

/**

* @param {Planning_Vakanties_VerwijderenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_verwijderen = /** @type {((inputs: Planning_Vakanties_VerwijderenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_VerwijderenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_verwijderen(inputs)
});
export { planning_vakanties_verwijderen as "planning.vakanties.verwijderen" }